import GridTextHoverLink from "@entrilia/shared/components/grid/GridTextHoverLink";
import type { ObjectClassDefinitionInfo } from "../../../../api/types/objectTypes";
import useClientContext from "../../../../context/useClientContext";
import { pageRoutes } from "../../../../routes";

interface Props {
  row: ObjectClassDefinitionInfo;
}

const ObjectNameCell = ({ row }: Props) => {
  const { clientCode } = useClientContext();

  return (
    <GridTextHoverLink
      to={`/${clientCode}/${pageRoutes.settings}/${pageRoutes.dataModel}/${pageRoutes.orgObjects}/${row.objectType}`}
      text={row.objectName}
    />
  );
};

export default ObjectNameCell;
